var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalonMetrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50014 2.42859C5.14689 2.42859 2.42871 5.14677 2.42871 8.50002C2.42871 11.8533 5.14689 14.5714 8.50014 14.5714C11.8534 14.5714 14.5716 11.8533 14.5716 8.50002C14.5716 5.14677 11.8534 2.42859 8.50014 2.42859ZM6.21971 3.86934L8.046 4.9622V6.29366L6.35146 7.52495L5.11046 7.0957L4.75407 4.95005C5.17492 4.50604 5.67114 4.14014 6.21971 3.86934ZM3.41289 9.3737L4.82571 7.96087L6.06428 8.38891L6.72121 10.4125L6.13228 11.3688L4.13296 11.251C3.77144 10.6789 3.52671 10.0408 3.41289 9.3737ZM7.60764 13.5836L6.88878 11.8782L7.47346 10.9268H9.52075L10.0745 11.8867L9.44303 13.5745C8.83663 13.6865 8.21513 13.6896 7.60764 13.5836ZM12.6846 11.5212L10.8486 11.4058L10.2791 10.4198L10.939 8.38891L12.1612 7.96634L13.5649 9.49634C13.4217 10.2271 13.1213 10.918 12.6846 11.5212ZM12.2474 4.95187L11.8898 7.09691L10.6512 7.52495L8.95671 6.29366V4.96159L10.7794 3.86873C11.329 4.14004 11.826 4.50678 12.2474 4.95187Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalonMetrica);
export default __webpack_public_path__ + "static/media/balonMetrica.d8c5bd87c22806424f3a7673bbd450d1.svg";
export { ForwardRef as ReactComponent };